"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayExtra = displayExtra;
exports.handleJobClick = handleJobClick;
const __1 = require("..");
const filter_1 = require("./filter");
const auto_1 = __importDefault(require("chart.js/auto"));
// @ts-nocheck
function displayExtra(resultsList) {
    var header = '';
    document.title = 'Calculatrices - Etat de Neuchâtel';
    // test if not iframe
    if (self == top)
        header = `
            <span class="title">${__1.TITLE}</span>
            <span class="description secondaryColor">${__1.DESCRIPTION}</span>
        `;
    let app = document.getElementById('app');
    app.innerHTML = `
        <style>
            :root {
                --fontColor: ${__1.FONT_COLOR};
                --linkColor: ${__1.LINK_COLOR};
            }
        </style>
        <div class="container">
            <div class="AEFcalculator">
                        <div class="row">
                            ${header}
                            <div class="col-lg-4 align-self-start">
                                <div class="filter-title">
                                    <span class="ph ph-faders-horizontal text-primary-700 text-2xl p-3 bg-primary-50 rounded-400"></span>
                                    <h2 class="heading-xs-bold title">Filtrer</h2>
                                </div>
                                <a id="clear-filters" href="#" style="display:none" tabindex="0">Effacer les filtres</a>
                                <div id="filters"></div>
                            </div>
                            <div class="col order-lg-1">
                                <div id="intro">${__1.INTRO}</div>
                                <div id="jobs"></div>
                            </div>

                        </div>

            </div>
        </div>
    `;
    if (resultsList.length > 0)
        (0, filter_1.createFilterComponent)();
    const jobs = document.createElement('div');
    jobs.innerHTML = `
            
                <div class="container">
                    <div class="row">
                        <div class="column">
                            <div class="header">

                                <div style="margin-bottom: 15px;">
                                    ${__1.SUBSCRIBE_LINK ? '<a class="subscribe link" href="' + __1.SUBSCRIBE_LINK + '" target="_blank">' : ''}
                                    ${__1.SUBSCRIBE_TEXT}
                                    ${__1.SUBSCRIBE_LINK ? '</a>' : ''}
                                    ${__1.SRHE_LINK ? '<a class="srhe link" href="' + __1.SRHE_LINK + '" target="_blank">' : ''}
                                    ${__1.SRHE_TEXT}
                                    ${__1.SRHE_LINK ? '</a><br/>' : ''}

                                </div>
                                <hr>
                                <div style="font-size: 25px">
                                 <b>Total Revenu</b> :<input id="revenu" type="number" class="form-text" style="background-color: var(--color-neutral-100);" placeholder="CHF">
                            	
                            	<button id="submit" type="submit" aria-hidden="true" style="padding: 10px !important;" class="nech-button__ratio  nech-button inline-flex items-center ease-default transition-all duration-300  text-neutral-50 relative bg-primary-700 hover:bg-primary-800 active:text-primary-600 active:bg-primary-800 rounded-400  cta-m  py-4  px-5  flex justify-center rounded-400 max-h-9  w-9 " tabindex="0">
								Calculer
								</button>
                            	</div>
                            </div>
                            <div id="count-jobs"></div>
                            <br>

                            <div id="job-list">
                          
                            </div>
                        </div>
                    </div>
                </div>

        `;
    const jobsElement = document.querySelector('#jobs');
    if (jobsElement) {
        jobsElement.appendChild(jobs);
    }
    else {
        console.error("Element with id 'jobs' not found.");
    }
    // Restore filter state from localStorage
    const selectedDomains = JSON.parse(localStorage.getItem('selectedDomains') || '[]'); // Added line
    selectedDomains.forEach((domain) => {
        const checkbox = document.querySelector(`.checkbox-container.taux- input[name="${domain}"]`);
        if (checkbox) {
            checkbox.checked = true;
        }
    });
    //updateAccordionVisibility();
    applyFilters();
    // Add event listeners to filter checkboxes
    document.querySelectorAll('.checkbox-container').forEach(checkbox => {
        checkbox.addEventListener('change', applyFilters);
    });
    // Attach the resetFilters function to the "clear-filters" button's click event
    const clearFiltersButton = document.getElementById('clear-filters');
    if (clearFiltersButton) {
        clearFiltersButton.addEventListener('click', resetFilters);
    }
}
function renderFilteredJobs(filteredJobs) {
    // Préparer labels et data
    const labels = __1.Resultslist.map(item => item.taux_prestation);
    const dataValues = __1.Resultslist.map(item => item.prix_parent);
    // Créer le canvas dynamiquement (ou dans index.html)
    let canvas = document.createElement("canvas");
    canvas.id = "taux-prix";
    document.body.appendChild(canvas);
    const data = {
        labels: labels,
        datasets: [{
                label: 'Prix',
                data: __1.Resultslist.map(item => item.prix_parent),
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)'
            }, {
                type: 'line',
                label: 'Contrib',
                data: __1.Resultslist.map(item => item.participation_communale),
                fill: false,
                borderColor: 'rgb(54, 162, 235)'
            }]
    };
    // Créer le graphique
    //const ctx = document.getElementById('taux-prix') as HTMLCanvasElement | null;
    const ctx = false;
    if (ctx) {
        new auto_1.default(canvas, {
            type: 'bar',
            data: {
                datasets: [{
                        label: 'Prix',
                        data: __1.Resultslist.map(item => item.prix_parent),
                        borderColor: 'rgb(255, 99, 132)',
                        backgroundColor: 'rgba(255, 99, 132, 0.2)'
                    }, {
                        type: 'line',
                        label: 'Contrib',
                        data: __1.Resultslist.map(item => item.participation_communale),
                        fill: false,
                        borderColor: 'rgb(54, 162, 235)'
                    }],
                labels: labels
            },
            options: {
                responsive: true,
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            }
        });
    }
    var revenu = document.getElementById('revenu').value;
    var printJobs = `
	`;
    var printCardJobs = ` <div class="container">
    <div class="row">
        `;
    let first = true;
    filteredJobs.forEach(element => {
        if (first) {
            printJobs += `
			<table border="0" width="100%" ><tbody><tr><td><table border="0" cellspacing="0" width="100%"><tbody>
			<tr><td width="35%" class="ms-vb">Prestations pour un revenu total de : <b>CHF ${new Intl.NumberFormat("fr-CH").format(element.revenu)}</b></td>
			</tr></tbody></table>
			<br>
			<br>
			`;
            first = false;
        }
        printJobs += `
		<br>
		<br>
        <div data-href="" class="anchorwrap taux-${element.taux_prestation}">
			
            <table border="0" width="100%" ><tbody><tr><td><table border="0" cellspacing="0" width="100%"><tbody>
			
			<tr><td >Taux d’accueil : <b>${element.taux_prestation}% ${element.prestations[element.prestations.length - 1].prestation}</b></td><td ></td></tr></tbody></table>
			<p>&nbsp;</p><table><tbody><tr><td style="font-weight: bold" class="ms-vb"></td><td style="font-weight: bold" class="ms-vb">A charge des parents</td>
			<td style="font-weight: bold" class="ms-vb">Participation communale</td><td style="font-weight: bold" class="ms-vb">Base de prix de référence</td>
			</tr>
						<tr><td width="25%" class="ms-vb"><b>Pourcentage de répartition :</b></td>
			<td width="15%" class="ms-vb">${element.taux_parent}%</td><td width="15%" class="ms-vb">${element.taux_communal}%</td><td ></td></tr>
			`;
        element.prestations.forEach((prestation) => {
            printJobs += `
	
				<tr><td width="25%" class="ms-vb"><b>${prestation.type_structure}:</b></td><td width="15%" class="ms-vb">CHF ${prestation.prix_parent}</td><td width="15%" class="ms-vb">CHF ${prestation.participation_communale}</td><td width="15%" class="ms-vb">CHF ${prestation.prix_reference}</td></tr>
				`;
        });
        printJobs += `
			</td></tr>
			</tbody></table>
			</td></tr>
			</tbody></table>
			</div>
		`;
    });
    printCardJobs += `</div></div>`;
    const jobListElement = document.getElementById('job-list');
    if (jobListElement) {
        jobListElement.innerHTML = printJobs;
    }
    /* const count = document.getElementById('count-jobs');
     if (count)
         count.innerHTML = '<h2><span class="nb">' + filteredJobs.length + '</span> Prestations par taux <span id="filtered">filtrées</span></h2><br>';
     */
}
function resetFilters() {
    document.querySelectorAll('.checkbox-container input:checked').forEach((checkbox) => {
        checkbox.checked = false;
    });
    applyFilters();
    (0, filter_1.updateAccordionVisibility)();
    const textFiltered = document.getElementById('filtered');
    const clearFiltersButton = document.getElementById('clear-filters');
    if (textFiltered && clearFiltersButton) {
        textFiltered.style.display = 'none';
        clearFiltersButton.style.display = 'none';
    }
}
function applyFilters() {
    const selectedDomains = Array.from(document.querySelectorAll('.checkbox-container.taux- input:checked')).map(e => Number(e.name));
    // Save filter state to localStorage
    localStorage.setItem('selectedDomains', JSON.stringify(selectedDomains)); // Added line
    const filteredJobs = __1.Resultslist.filter(job => {
        return (selectedDomains.length === 0 || selectedDomains.includes(parseInt(job.taux_prestation)));
    });
    renderFilteredJobs(filteredJobs);
    handleJobClick();
    const clearFiltersButton = document.getElementById('clear-filters');
    const textFiltered = document.getElementById('filtered');
    if (textFiltered && clearFiltersButton && (selectedDomains.length)) {
        clearFiltersButton.style.display = 'block';
        textFiltered.style.display = 'inline-block';
    }
}
function handleJobClick() {
    let elems = document.querySelectorAll('.card-link ');
    Array.from(elems).forEach((element) => {
        element.addEventListener("click", function (e) {
            e.preventDefault();
            let link = e.currentTarget;
            if (link.pathname) {
                window.history.pushState('', "Détail", link.pathname);
                var popStateEvent = new PopStateEvent('popstate');
                dispatchEvent(popStateEvent);
            }
        });
    });
}
